import { motion } from "framer-motion";
import { Flame, Clapperboard, Croissant, Coffee, UtensilsCrossed, Puzzle, Laptop, PawPrint, MapPinned } from "lucide-react";
import { useLang } from "@/i18n";

const icons = [Flame, Clapperboard, Croissant, Coffee, UtensilsCrossed, Puzzle, Laptop, PawPrint, MapPinned];

export default function Experiences() {
  const { t } = useLang();
  const items = t("exp.items");

  return (
    <section id="experiente" className="py-24 md:py-32" data-testid="experiences-section">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <motion.p initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8 }}
                className="text-xs md:text-sm tracking-[0.25em] uppercase font-bold text-walnut flex items-center gap-3">
                <span className="inline-block w-10 h-px bg-terracotta" />
                {t("exp.eyebrow")}
              </motion.p>
              <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: 0.1 }}
                className="mt-5 font-serif font-medium text-4xl md:text-5xl leading-[1.05] tracking-tight text-main">
                {t("exp.title")}
              </motion.h2>
              <motion.div
                initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 1, delay: 0.2 }}
                className="mt-10 overflow-hidden rounded-3xl group hidden lg:block"
              >
                <img src="/assets/experiences-world.webp" alt="Seri la foc în grădina Imperfect House — oameni din toată lumea" loading="lazy"
                  className="w-full h-auto group-hover:scale-[1.02] transition-transform duration-700" />
              </motion.div>
            </div>
          </div>

          <div className="lg:col-span-8 grid sm:grid-cols-2 gap-4">
            {items.map((item, i) => {
              const Icon = icons[i] || Flame;
              return (
                <motion.div
                  key={item.t}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-40px" }}
                  transition={{ duration: 0.7, delay: (i % 4) * 0.08 }}
                  className={`bg-cream-light border border-warm-grey/40 rounded-3xl p-7 hover:border-terracotta/40 hover:-translate-y-1 transition-all duration-500 ${i % 3 === 0 ? "sm:mt-8" : ""}`}
                  data-testid={`experience-${i}`}
                >
                  <div className="w-11 h-11 rounded-full bg-sage/25 flex items-center justify-center">
                    <Icon size={19} className="text-green-dark" />
                  </div>
                  <h3 className="mt-5 font-serif text-xl md:text-2xl text-main">{item.t}</h3>
                  <p className="mt-2 text-sm text-brown/80 font-light leading-relaxed">{item.d}</p>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
